// extracted by mini-css-extract-plugin
module.exports = {"languageWrapper":"style_languageWrapper__IK90c"};